// subscription-manager.js
(function() {
  'use strict';

  if (!window.subscriptionEventListenersAdded) {
    window.subscriptionEventListenersAdded = true;
    let initTimer = null;

    const applyMode = (mode) => {
      const buyOnceCheckboxes = document.querySelectorAll(
        '.subscription__checkbox[data-sync-group="subscription"][data-type="buy-once"]'
      );
      const subscribeCheckboxes = document.querySelectorAll(
        '.subscription__checkbox[data-sync-group="subscription"][data-type="subscribe"]'
      );

      const isSubscribe = mode === 'subscribe';
      buyOnceCheckboxes.forEach((cb) => (cb.checked = !isSubscribe));
      subscribeCheckboxes.forEach((cb) => (cb.checked = isSubscribe));

      // Update dropdown visibility
      document.querySelectorAll('.subscription__select-wrapper').forEach((w) => {
        w.style.display = isSubscribe ? 'block' : 'none';
        w.classList.toggle('show', isSubscribe);
      });

      updateSellingPlanInputs();
    };

    const initSubscriptionState = () => {
      const buyOnceCheckboxes = document.querySelectorAll('.subscription__checkbox[data-type="buy-once"]');
      const subscribeCheckboxes = document.querySelectorAll('.subscription__checkbox[data-type="subscribe"]');
      if (!buyOnceCheckboxes.length && !subscribeCheckboxes.length) return;

      // If markup preloads subscribe as checked anywhere, honor that deterministically.
      const isSubscribe = Array.from(subscribeCheckboxes).some((cb) => cb.checked || cb.hasAttribute('checked'));
      const isBuyOnce = Array.from(buyOnceCheckboxes).some((cb) => cb.checked || cb.hasAttribute('checked'));

      if (!isSubscribe && !isBuyOnce) {
        applyMode('buy-once');
        return;
      }
      applyMode(isSubscribe ? 'subscribe' : 'buy-once');
    };

    const scheduleInit = () => {
      if (initTimer) window.clearTimeout(initTimer);
      initTimer = window.setTimeout(() => {
        initTimer = null;
        initSubscriptionState();
      }, 0);
    };

    const updateSellingPlanInputs = () => {
      const subscribeChecked = Array.from(
        document.querySelectorAll('.subscription__checkbox[data-sync-group="subscription"][data-type="subscribe"]')
      ).some((cb) => cb.checked);

      const select = document.querySelector('.subscription__select');
      const planId = subscribeChecked && select && select.value ? select.value : '';

      // Ensure product-form submissions include selling_plan when subscribing.
      document.querySelectorAll('product-form form').forEach((form) => {
        const existing = form.querySelector('input[name="selling_plan"]');
        if (!subscribeChecked || !planId) {
          existing && existing.remove();
          return;
        }
        const input = existing || document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = planId;
        if (!existing) form.appendChild(input);
      });
    };

    /**
     * Make the entire option card clickable (radio-like behavior).
     * Some themes hide the checkbox input, so relying on native input clicks
     * can make one of the options feel "unclickable".
     */
    document.addEventListener('click', function (event) {
      const wrapper = event.target.closest('.subscription__checkbox-wrapper');
      if (!wrapper) return;

      // If user clicked the actual checkbox, let the native interaction happen.
      if (event.target && event.target.matches && event.target.matches('input.subscription__checkbox')) return;

      const checkbox = wrapper.querySelector('.subscription__checkbox[data-sync-group="subscription"]');
      if (!checkbox || checkbox.disabled) return;

      applyMode(checkbox.dataset.type === 'subscribe' ? 'subscribe' : 'buy-once');
      // Fire one change event so any other listeners (e.g. custom add-to-cart sync)
      // pick up the normalized state.
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      event.preventDefault();
    });

    /** ✅ Handle checkbox changes (Buy Once / Subscribe) **/
    // Use capture so we normalize state BEFORE other scripts read it.
    document.addEventListener(
      'change',
      function (event) {
      const checkbox = event.target.closest('.subscription__checkbox[data-sync-group="subscription"]');
      if (!checkbox) return;

      const mode = checkbox.dataset.type === 'subscribe' ? 'subscribe' : 'buy-once';
      applyMode(mode);
    },
      true
    );

    /** ✅ Handle dropdown syncing across all sections **/
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('subscription__select')) {
        const value = e.target.value;
        document.querySelectorAll('.subscription__select').forEach(select => {
          if (select !== e.target) select.value = value;
        });
        updateSellingPlanInputs();
      }
    });

    // Initialize once now (or on DOM ready), then keep re-initializing after dynamic injections.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSubscriptionState);
    } else {
      initSubscriptionState();
    }

    const mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!node || node.nodeType !== Node.ELEMENT_NODE) continue;
          const el = /** @type {Element} */ (node);
          if (
            (typeof el.matches === 'function' && (el.matches('.subscription__checkbox') || el.matches('.subscription__select-wrapper'))) ||
            (typeof el.querySelector === 'function' &&
              (el.querySelector('.subscription__checkbox') || el.querySelector('.subscription__select-wrapper')))
          ) {
            scheduleInit();
            return;
          }
        }
      }
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
